import { VisibilityIcon, VisibilityOffIcon } from '@medly-components/icons';
import { useCallback } from 'react';

/**
 * PasswordSuffix Component Props
 * @typedef {object} Props
 * @property {boolean} showPassword - A boolean value indicating whether the password is currently shown or hidden.
 * @property {function(boolean): void} setShowPassword - Callback function to update the showPassword state.
 */
interface Props {
    showPassword: boolean;
    setShowPassword: (showPassword: boolean) => void;
}

/**
 * PasswordSuffix Component
 * A reusable component that renders an eye-like symbol to show or hide the password.
 * When the eye symbol is clicked, it toggles the visibility of the password.
 * This component is designed to be used alongside a password input field.
 */
export const PasswordSuffix = ({ showPassword, setShowPassword }: Props) => {
    const onChange = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword, setShowPassword]);

    if (showPassword) {
        return <VisibilityOffIcon style={{ cursor: 'pointer' }} onClick={onChange} />;
    }
    return <VisibilityIcon style={{ cursor: 'pointer' }} onClick={onChange} />;
};
